import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-black text-gray-400 px-6 py-16 border-t border-gray-900">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="md:col-span-1">
            <Image
              src="/ktr_isotipo.svg"
              alt="KTR Capital"
              width={40}
              height={40}
              className="mb-4"
            />
            <p className="text-xs text-gray-500 leading-relaxed font-light">
              KTR Capital<br />
              Austin, Texas<br />
              United States
            </p>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">Firm</div>
            <ul className="space-y-2 text-sm font-light">
              <li><Link href="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link href="/platform" className="hover:text-white transition-colors">Platform</Link></li>
              <li><Link href="/research" className="hover:text-white transition-colors">Research</Link></li>
              <li><Link href="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">Investors</div>
            <ul className="space-y-2 text-sm font-light">
              <li><Link href="/contact" className="hover:text-white transition-colors">Request relationship intro</Link></li>
              <li><Link href="/sign-in" className="hover:text-white transition-colors">Investor sign in</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">Legal</div>
            <ul className="space-y-2 text-sm font-light">
              <li><Link href="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link href="/terms" className="hover:text-white transition-colors">Terms of Service</Link></li>
              <li><Link href="/disclosures" className="hover:text-white transition-colors">Disclosures</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-900 pt-8 space-y-4">
          <p className="text-xs text-gray-600 font-light leading-relaxed">
            KTR Capital is an Exempt Reporting Adviser filed with the SEC under Regulation D.
            This website is intended for informational purposes and is not an offer to sell, or a
            solicitation of an offer to buy, any securities. Any such offer or solicitation will be
            made only by means of confidential offering documents and only to qualified investors
            in jurisdictions where permitted by law.
          </p>
          <p className="text-xs text-gray-600 font-light leading-relaxed">
            Past performance does not guarantee future results. Investment in private securities
            involves substantial risk, including the risk of total loss.
          </p>
          <p className="text-xs text-gray-700 font-light pt-2">
            © {year} KTR Capital. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
